import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

function normalizeDepartmentPayload(department) {
    const name = (department?.name || "").trim();

    let colorHex = department?.colorHex ?? null;
    if (typeof colorHex === "string") {
        colorHex = colorHex.trim();
        if (colorHex === "") colorHex = null;
    }

    return { name, colorHex };
}

export const createDepartment = (department) => {
    return new Promise(async (resolve) => {
        try {
            const token = Cookies.get("Bearer");
            const payload = normalizeDepartmentPayload(department);

            const response = await axios.post(
                `${FIRMFLOWURL}api/Department/create`,
                payload,
                {
                    headers: { Authorization: token },
                }
            );

            resolve({ ...response, success: true });
        } catch (err) {
            console.log("error on creating department", err);

            const status = err?.response?.status;

            if (status === 401) {
                Cookies.remove("Bearer");
                window.location.replace("/");
                return;
            }

            const serverMessage =
                err?.response?.data?.message ||
                err?.response?.data?.Message ||
                err?.message;

            resolve({
                success: false,
                message: serverMessage || "Error creating department",
            });
        }
    });
};
